import axios from 'axios'

export default {
  search (query, facets, page) {
    return axios.get('/api/v2/notices/search', {
      params: {
        query: query,
        facets: facets,
        page: page
      }
    })
  },
  updates (notices) {
    return axios.post('/api/v2/notices/updates', {
      notices: notices
    })
  },
}
